import { create } from "zustand";
import { ApiCallModalType, ApiCallsModalStore, ModalDataType } from "./types";

export const apiCallsModalStore = create<ApiCallsModalStore>((set, get) => ({
  modal: null,
  open: (type: ApiCallModalType, data: ModalDataType["data"]) =>
    set({ modal: { type: type as any, data: data as any } }),
  close: () => set({ modal: null }),
}));

export const openLoadingModal = (loadingModalPayload?: {
  title: string;
  description: string;
  disableClose?: boolean;
}) => {
  apiCallsModalStore
    .getState()
    .open(ApiCallModalType.LOADING, loadingModalPayload);
};
export const closeLoadingModal = () => {
  if (apiCallsModalStore.getState().modal?.type === ApiCallModalType.LOADING) {
    apiCallsModalStore.getState().close();
  }
};

export const openErrorModal = (errorModalPayload?: {
  title: string;
  description: string;
  submitText?: string;
  onSubmit?: () => void;
}) => {
  apiCallsModalStore
    .getState()
    .open(ApiCallModalType.ERROR, errorModalPayload);
};

export const closeErrorModal = () => {
  if (apiCallsModalStore.getState().modal?.type === ApiCallModalType.ERROR) {
    apiCallsModalStore.getState().close();
  }
};
